import { createFileRoute } from "@tanstack/react-router";
import About from "@/pages/About";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/zh/about")({
  head: () => pageHead("/about", "zh"),
  component: About,
});
